<template>
    <div class="v-application--wrap grey lighten-4">
        <the-layout-drawer />
        <the-layout-toolbar />
        <the-layout-content/>

        <AVIChat
            v-if="$can('avi_login', 'AVIChat', 'avitoken')"
        />
        <the-layout-to-top-fab />
        <the-layout-footer />
        <ComprehensivePrivacyNotice :dialog="dialogComprehensivePrivacyNotice" :submit="submitComprehensivePrivacyNotice " />
        <ConfidentialityDataProcessingLetter :dialog="dialogConfidentialityDataProcessingLetter" :submit="submitConfidentialityDataProcessingLetter" />
        <PolicyWhatsappBusiness :dialog="dialogPolicyWhatsappBusiness" :submit="submitPolicyWhatsappBusiness" />
    </div>
</template>

<script>
import TheLayoutDrawer from './TheLayoutDrawer.vue'
import TheLayoutToolbar from './TheLayoutToolbar.vue'
import TheLayoutContent from './TheLayoutContent.vue'
// import TheLayoutFab from './TheLayoutFab.vue'
import AVIChat from '@/components/AVIChat.vue'
import TheLayoutToTopFab from './TheLayoutToTopFab.vue'
import TheLayoutFooter from './TheLayoutFooter.vue'
import ComprehensivePrivacyNotice from './ComprehensivePrivacyNotice.vue'
import ConfidentialityDataProcessingLetter from './ConfidentialityDataProcessingLetter.vue'
import PolicyWhatsappBusiness from './PolicyWhatsappBusiness.vue'

// UTILS
import { mapActions, mapGetters } from 'vuex'

const developmentMode = process.env.NODE_ENV === 'development'
export default {
  name: 'TheLayout',
  components: {
    TheLayoutDrawer,
    TheLayoutToolbar,
    TheLayoutContent,
    ComprehensivePrivacyNotice,
    ConfidentialityDataProcessingLetter,
    PolicyWhatsappBusiness,
    TheLayoutToTopFab,
    AVIChat,
    TheLayoutFooter
  },
  data() {
    return {
      developmentMode
    }
  },
  computed: {
    ...mapGetters('account', ['comprehensivePrivacyNotice', 'confidentialityDataProcessingLetter', 'policyWhatsappBusiness', 'userGroup']),
    isProvider() {
      const { name = 'Proveedor' } = this.userGroup
      return ['Proveedor'].includes(name)
    },
    dialogComprehensivePrivacyNotice() {
      const { comprehensivePrivacyNotice, confidentialityDataProcessingLetter, policyWhatsappBusiness, isProvider } = this
      return !!isProvider && !comprehensivePrivacyNotice && !confidentialityDataProcessingLetter && !policyWhatsappBusiness
    },
    dialogConfidentialityDataProcessingLetter() {
      const { comprehensivePrivacyNotice, confidentialityDataProcessingLetter, policyWhatsappBusiness, isProvider } = this
      return !!isProvider && !!comprehensivePrivacyNotice && !confidentialityDataProcessingLetter && !policyWhatsappBusiness
      // return isProvider && comprehensivePrivacyNotice && !confidentialityDataProcessingLetter && !policyWhatsappBusiness
    },
    dialogPolicyWhatsappBusiness() {
      const { comprehensivePrivacyNotice, confidentialityDataProcessingLetter, policyWhatsappBusiness, isProvider } = this
      return !!isProvider && !!comprehensivePrivacyNotice && !!confidentialityDataProcessingLetter && !policyWhatsappBusiness
    }

  },
  methods: {
    ...mapActions('account', ['submitComprehensivePrivacyNotice', 'submitConfidentialityDataProcessingLetter', 'submitPolicyWhatsappBusiness'])
  }
}
</script>

<style>
.v-navigation-drawer--fixed {
  -webkit-box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2),
    0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2),
    0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
}
.v-application--wrap{
  position: fixed;
}
</style>
